import * as qs from 'qs'

export function json2qs<T>(obj: T) {
    return qs.stringify(obj, { allowDots: true })
}
